var _defineProperty = require("@babel/runtime/helpers/defineProperty");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const _require = require('spark-md5'),
  hash = _require.hash;
const _require2 = require('../lib/evaluateSource'),
  evaluateSource = _require2.evaluateSource;

/**
  * @function evalute - evaluate generatePickerOptionsFromArrayOfLabeledObjectsBehavior
  *
  * Behavior ingests an array of values and creates an options object with appropriate titles
  * (from labels) and keys that are hashes of the transcribed title. Options missing labels
  * or possessing labels that are empty strings are filtered out.
  *
  * values: list of proto-options
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const values = await evaluateSource(source.values, content, parentContentPath, transientContext, nativeFunctions);
  const entitledValues = (values || []).filter(option => option.label).map(baseObject => _objectSpread(_objectSpread({}, baseObject), {}, {
    title: baseObject.label,
    identifier: hash(baseObject.label)
  })).filter(option => option.label !== ' ');

  /* eslint-disable-next-line no-console */
  if (entitledValues.length === 0) console.log('None of the objects in the array posess labels');
  return entitledValues;
};
module.exports = {
  evaluate
};